import * as v from "valibot";

import { rpcContract } from "../rpc";

export const publicWorldsQueryRpcContract = rpcContract({
  name: "publicWorlds",
  paramsSchema: v.object({
    handle: v.pipe(v.string(), v.minLength(3), v.maxLength(64), v.regex(/^[a-z0-9_\-.]+$/)),
  }),
  resultSchema: v.object({
    highlightedPost: v.nullable(
      v.object({
        id: v.string(),
        title: v.string(),
        description: v.nullable(v.string()),
        imageUrl: v.nullable(v.string()),
        worldId: v.nullable(v.string()),
      }),
    ),
    worlds: v.array(
      v.object({
        id: v.string(),
        name: v.string(),
        mediaUrl: v.nullable(v.string()),
        mediaPositionX: v.nullable(v.number()),
        mediaPositionY: v.nullable(v.number()),
        postCount: v.number(),
        status: v.union([v.literal("live"), v.literal("draft")]),
        createdAt: v.string(),
        updatedAt: v.string(),
      }),
    ),
  }),
});

export type PublicWorldsQueryParams = v.InferOutput<(typeof publicWorldsQueryRpcContract)["paramsSchema"]>;
export type PublicWorldsQueryResult = v.InferOutput<(typeof publicWorldsQueryRpcContract)["resultSchema"]>;
export type PublicWorld = v.InferOutput<(typeof publicWorldsQueryRpcContract)["resultSchema"]>["worlds"][0];
export type PublicHighlightedPost = v.InferOutput<
  (typeof publicWorldsQueryRpcContract)["resultSchema"]
>["highlightedPost"];
